import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/visitImagesConstants';

const initialState = {
  visitImages: [],
  visitImage: null,
  loading: true,
};

const visitImagesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_VISIT_IMAGES:
      return {
        ...initialState,
      };
    case types.CLEAR_SELECTED_VISIT_IMAGE:
      return {
        ...state,
        visitPart: null,
      };
    case types.GET_VISIT_IMAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        visitImages: payload,
      };
    case types.GET_VISIT_IMAGES_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_VISIT_IMAGES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SELECT_VISIT_IMAGE:
      return {
        ...state,
        visitImage: payload,
      };
    default:
      return state;
  }
};

export default visitImagesReducer;
